// extracted by mini-css-extract-plugin
module.exports = {"text":"TabStatus_text__1eqdu","small":"TabStatus_small__3enhz","normal":"TabStatus_normal__2GTy3","space":"TabStatus_space__2xYdZ","schedule":"TabStatus_schedule__yv2Vk"};